<script setup>
import { onMounted, ref, watch } from 'vue';

/**
 * smartwel 흐름용 성공 토스트 (시연 v2.1 toast-payment 스타일).
 * - 표시 후 자동으로 사라짐 (기본 2.5초)
 * - v-if로 마운트하면 자동으로 노출, duration 후 close emit
 */
const props = defineProps({
  message: { type: String, required: true },
  duration: { type: Number, default: 2500 },
});

const emit = defineEmits(['close']);

const visible = ref(false);
let timer = null;

const open = () => {
  visible.value = true;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    visible.value = false;
    // 페이드 아웃 후 부모에 알림
    setTimeout(() => emit('close'), 250);
  }, props.duration);
};

onMounted(open);

watch(() => props.message, open);
</script>

<template>
  <div class="smartwel-toast" :class="{ show: visible }">
    <span class="check">✓</span>
    {{ message }}
  </div>
</template>

<style lang="scss" scoped>
.smartwel-toast {
  position: fixed;
  left: 50%;
  bottom: calc(56px + var(--safe-area-bottom, 0px) + 100px);
  transform: translateX(-50%);
  z-index: 1200;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  background: #10b981;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 100px;
  white-space: nowrap;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease-out;
  pointer-events: none;
}

.smartwel-toast.show {
  opacity: 1;
  visibility: visible;
}

.check {
  font-weight: 700;
}
</style>
